import { HelpCircle } from 'lucide-react';

interface FloatingHelpButtonProps {
  onClick: () => void;
}

export default function FloatingHelpButton({ onClick }: FloatingHelpButtonProps) {
  return (
    <button
      onClick={onClick}
      style={{
        position: 'fixed',
        bottom: '24px',
        right: '24px',
        width: '56px',
        height: '56px',
        borderRadius: '50%',
        background: 'linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)',
        border: 'none',
        color: 'white',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 8px 24px rgba(37, 99, 235, 0.4)',
        transition: 'all 0.3s ease',
        zIndex: 9998
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'scale(1.1)';
        e.currentTarget.style.boxShadow = '0 12px 32px rgba(37, 99, 235, 0.5)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'scale(1)';
        e.currentTarget.style.boxShadow = '0 8px 24px rgba(37, 99, 235, 0.4)';
      }}
      title="Ayuda y glosario"
    >
      <HelpCircle size={24} />
    </button>
  );
}
